// extracted by mini-css-extract-plugin
export default {"box":"Box_box__cUyV1","curvy":"Box_curvy__uxXJn"};